<div class="save-as-batch-container">
  <!-- In next div we define window title section -->
  <div class="window-header" fxLayout="row">
    @if (isRatesInitialized) {
      <div fxLayout="row" fxFlex="91" class="window-header__left-group">
        <button (click)="closeWindow(false)" class="window-header__dialog-back">
          <img class="window-header__dialog-back-button" src="../../../assets/icons/back.svg" />
          <span>Back</span>
        </button>
        <span class="window-header__title" mat-dialog-title>
          {{ carrierName }} | {{ data?.addToBatchId ? 'Added to ' : '' }} Batch:
        </span>
        <app-edit-batch-name [shopMetadata]="shopMetadata$ | async" [batch]="orderBatch"></app-edit-batch-name>
        <carrier-logo size="small" [carrierName]="isBestMatch ? 'pdq' : orderBatch?.selectedCarrier?.type?.name">
        </carrier-logo>
      </div>
    } @else {
      <div fxLayout="row" fxFlex="91" class="window-header__left-group">
        <skeleton-display-text size="large" style="width: 145px"></skeleton-display-text>
      </div>
    }

    <div fxFlex="9" class="window-header__right-group">
      <div class="window-header__dialog-close">
        <pdq-button
          [size]="'small'"
          [icon]="'close'"
          [variant]="'ghost'"
          [loading]="isWaitingForBatchRemove"
          (onClick)="closeWindow(true)">
        </pdq-button>
        <!-- <img class="close-image" (click)="closeWindow(true)" src="../../../../assets/icons/cancel.svg" /> -->
      </div>
    </div>
  </div>

  @if (isRatesInitialized) {
    <div class="window-body">
      <div class="window-errors">
        @if (
          !isPerformingRatesRetry &&
          (isMissingRatesForAllOrders() ||
            invalidOrdersRatesErrorMessages?.length ||
            processedErrorMessagesTexts?.ordersMissingRatesText)
        ) {
          <pdq-banner class="window-errors__banner" variant="danger" bannerTitle="Rates unavailable for some orders">
            <ul class="fix-list">
              <li>
                @if (processedErrorMessagesTexts?.ordersMissingRatesText) {
                  <span>
                    {{ processedErrorMessagesTexts.ordersMissingRatesText }}
                  </span>
                }
              </li>
              @for (errorMessage of invalidOrdersRatesErrorMessages; track errorMessage) {
                <span>
                  <!-- <span *ngIf="errorMessage.type === 'default'">
                  {{ errorMessage.text }}
                </span> -->
                  @if (errorMessage.type === 'api') {
                    <li>
                      <span>
                        {{ errorMessage.text }}
                      </span>
                      <span class="error-retry-button" (click)="onErrorBannerRetryClick(errorMessage.orderId)">
                        {{ 'Retry to get rate' }}
                      </span>
                    </li>
                  }
                </span>
              }
            </ul>
          </pdq-banner>
        }
        @if (orderBatch?.selectedCarrier?.isTestMode) {
          <pdq-banner class="window-errors__banner" variant="attention" bannerTitle="Carrier is in Test Mode">
            <ul class="fix-list">
              <li>This carrier is currently in test mode, and all labels purchased will be test labels.</li>
            </ul>
          </pdq-banner>
        }
        @if (isPerformingRatesRetry) {
          <pdq-banner class="window-errors__banner" variant="attention" bannerTitle="API response issue">
            <ul>
              <li>
                Sorry, there seem to be slowness in {{ carrierType?.name }} API.
                <span style="font-weight: 600">We'll automatically refresh this batch shortly!</span>
              </li>
            </ul>
          </pdq-banner>
        }
        @if (isShowSuggestedAddressesBanner) {
          <pdq-banner class="window-errors__banner" variant="regular" bannerTitle="Addresses slightly modified">
            <ul>
              <li>
                Slight modifications were made to the formatting of some of the order's addresses so they're compatible
                with all carriers. Modifications will only be saved once assigned to delivery.
              </li>
            </ul>
          </pdq-banner>
        }
      </div>
      <pdq-tabs-group (onChange)="onChangeTabSelection($event)" [leftMargin]="'small'">
        @for (config of tabsConfigData; track config) {
          <pdq-tab [value]="config.value" [active]="config.active" [disabled]="isLoadingRates()" [label]="config.label">
          </pdq-tab>
        }
      </pdq-tabs-group>
      <div class="total-batch-info-div-upper">
        <div class="total-batch-info-div-upper__dropdown-buttons">
          @if (isBestMatch || !isEmptyStateOn) {
            <div class="dropdown-button">
              <button
                mat-button
                [matMenuTriggerFor]="providersMenu"
                [disabled]="isLoadingRates() || data?.addToBatchId"
                (menuOpened)="finalProvidersMenuOpened = true"
                (menuClosed)="finalProvidersMenuOpened = false"
                [ngClass]="getDropdownButtonClass(finalProvidersMenuOpened)">
                <span class="dropdown-text">{{
                  isBestMatch ? getCarrierSelectionNameForBestMatch() : selectedProvider
                }}</span>
                <span class="select-arrow"></span>
              </button>
              <mat-menu #providersMenu="matMenu" advanced-filters__panel>
                @if (!isBestMatch) {
                  <span>
                    @for (provider of getSelectedServiceLevelProviders(); track provider; let i = $index) {
                      <button mat-menu-item (click)="onChangeServiceLevelFinalProviderSelection(provider)">
                        <span class="table-component-cell-dropdown-text">{{ provider }}</span>
                      </button>
                    }
                  </span>
                } @else {
                  @for (providerObject of getSortedProvidersForBestMatch(); track trackByFn($index, providerObject)) {
                    <button mat-menu-item class="provider-item" (click)="onChangeBestMatchProvider(providerObject)">
                      <span class="table-component-cell-dropdown-text">{{ providerObject.displayName }}</span>
                      <span class="provider-item-additional-text">{{
                        providerObject.arrivingOnTimeDisplayString
                      }}</span>
                      <span class="provider-item-total-shipment-cost">
                        {{ providerObject.totalShipmentCostDisplayString }}
                      </span>
                    </button>
                  }
                }
              </mat-menu>
            </div>
          }
          <span class="total-batch-info-div-upper__dropdown-buttons__pickup_text"> Pickup on </span>
          <div style="display: flex; align-items: center">
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook - Remove mat-form-field usage, migrate/develop storybook datepicker instead mat-datepicker  -->
            <mat-form-field>
              <pdq-button
                (onClick)="picker.open()"
                [disabled]="!scheduledPickupIsSupported || data?.addToBatchId"
                [icon]="calendar"
                [loading]="isLoadingRates()"
                variant="ghost">
                <span class="dropdown-text">{{ formatHoursOffsetDateString(selectedOffsetOption) }}</span>
              </pdq-button>
              <input
                (dateInput)="onDatePickerChangeSelectedHoursOffset($event.value)"
                [min]="startDate"
                [max]="endDate"
                style="display: none"
                matInput
                [matDatepicker]="picker" />
              <mat-datepicker [startAt]="currentDate" #picker> </mat-datepicker>
            </mat-form-field>
            @if (isShowSaturdayDeliveryOption && !isEmptyStateOn) {
              <pdq-checkbox
                #saturdayCheckbox
                label="Saturday delivery"
                [checked]="isSaturdayDeliveryChosen"
                [disabled]="isLoadingRates() || data?.addToBatchId"
                (onChange)="onChangeSaturdayDelivery($event)">
              </pdq-checkbox>
            }
          </div>
        </div>
        @if (!isEmptyStateOn) {
          <div
            [ngClass]="{
              'delivery-promise-info__ontime': batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.ONTIME,
              'delivery-promise-info__late':
                batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.LATE ||
                batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.UNKNOWN,
              'delivery-promise-info__mixed': batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.MIXED,
            }">
            <img
              class="delivery-promise-info__icon"
              src="{{ '../../../../assets/icons/' + getBatchPromiseInfoIconName() }}" />
            <div>{{ getBatchPromiseInfoText() }}</div>
          </div>
        }
        <div class="assign-buttons-div">
          <pdq-button
            size="medium"
            [label]="'Assign selected'"
            variant="secondary"
            [disabled]="isAssignSelectedOrdersButtonDisabled()"
            (onClick)="purchaseLabelsForSelectedOrders()">
          </pdq-button>
          <pdq-button
            size="medium"
            [label]="'Assign all'"
            variant="primary"
            [disabled]="isAssignOrdersButtonDisabled()"
            (onClick)="purchaseLabelsForAllOrders()">
          </pdq-button>
        </div>
      </div>
      <div class="rates-table-div">
        <pdq-save-as-batch-table
          [rows]="rows"
          [columnsConfig]="columns"
          (onSelectRow)="onSelectRow($event)"
          [isDisableHeaderButtons]="isLoadingRates()"
          (changeColumnDropdownOption)="changeColumnDropdownOption($event)"
          (fireColumnButtonEvent)="fireColumnButtonEvent($event)"
          (onRetryButtonClick)="onRetryButtonClick($event)"
          (onChangeSaturdayDelivery)="onChangeOrderSaturdayDelivery($event)"
          (sort)="sortColumns($event)"
          [currentTab]="selectedServiceLevel">
        </pdq-save-as-batch-table>
      </div>
      <div class="total-batch-info-div-lower">
        @for (val of totalRatesData; track val) {
          <div>
            @if (val.value) {
              <div class="data-div">
                <span class="data-value">
                  {{ val.value }}
                </span>
                <span class="data-text">
                  {{ ' ' + val.text }}
                </span>
              </div>
            } @else {
              <div class="data-text">
                {{ 'Missing data' }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <skeleton-smartbatch-dialog></skeleton-smartbatch-dialog>
  }
</div>
